/**
 * Form state reading utilities.
 * @module ui/form
 */

import { DEFAULT_BANNER } from "../config";

/**
 * Reads all insertion options from the form DOM elements.
 * @returns {{tocEnabled: boolean, dividerAsPageBreak: boolean, headingBreakMode: string, sbiEnabled: boolean, coverPageEnabled: boolean, sbiOptions: object|null}}
 */
export function readFormOptions() {
  const tocEnabled = document.getElementById("toc-check").checked;
  const dividerAsPageBreak = document.getElementById("divider-pagebreak-check").checked;
  const headingBreakMode = document.getElementById("heading-pagebreak-select").value;
  const sbiEnabled = document.getElementById("sbi-header-check").checked;
  const coverPageEnabled = document.getElementById("sbi-cover-check").checked;
  const needsMeta = sbiEnabled || coverPageEnabled;
  const sbiOptions = needsMeta ? {
    docType:    document.getElementById("sbi-doc-type").value.trim(),
    docLabel:   document.getElementById("sbi-doc-label").value.trim(),
    version:    document.getElementById("sbi-doc-version").value.trim(),
    visibility: document.getElementById("sbi-doc-visibility").value,
    bannerText: document.getElementById("sbi-banner-text").value.trim() || DEFAULT_BANNER,
    email:      document.getElementById("email-input").value.trim(),
  } : null;

  return { tocEnabled, dividerAsPageBreak, headingBreakMode, sbiEnabled, coverPageEnabled, sbiOptions };
}
